import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

export const filterSchema: Schema = {
  status: {
    label: "Статус",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все статусы", value: "" },
      { label: "Активна", value: "ACTIVE" },
      { label: "Просрочена", value: "PAST_DUE" },
      { label: "Отменена", value: "CANCELED" },
      { label: "Истекла", value: "EXPIRED" },
    ],
  },
  renewSubscription: {
    label: "Автопродление",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все", value: "" },
      { label: "Да", value: "true" },
      { label: "Нет", value: "false" },
    ],
  },
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};

// renewSubscription — Boolean-поле; приводим строку select-фильтра к boolean
// и убираем пустое значение ("Все") явно, как в productPurchases.
const BOOLEAN_FILTER_KEYS = new Set(["renewSubscription"]);

export function normalizeSubscriptionsFilter(
  filter: Record<string, unknown>
): Record<string, unknown> {
  return Object.entries(filter).reduce<Record<string, unknown>>(
    (normalized, [key, value]) => {
      if (value === "" || value === null || value === undefined) {
        return normalized;
      }

      if (BOOLEAN_FILTER_KEYS.has(key) && typeof value === "string") {
        normalized[key] = value === "true";
        return normalized;
      }

      normalized[key] = value;
      return normalized;
    },
    {}
  );
}
